import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControlledPhoneInput } from './ControlledInputs';
import type { RegionCode } from 'google-libphonenumber';

interface Props {
  disabled?: boolean;
  tabIndex?: number;
  onPhoneValidationStatusChange?: (isValid: boolean) => void;
  onBlur?: () => void;
  isSelectMenuDisabled?: boolean;
  initialIsoCode?: RegionCode | null;
  onIsoCodeChange?: (isoCode: RegionCode) => void;
  filteredCountries?: RegionCode[];
}
export const PhoneInput = ({
  disabled,
  tabIndex,
  onPhoneValidationStatusChange,
  onBlur,
  isSelectMenuDisabled,
  initialIsoCode,
  onIsoCodeChange,
  filteredCountries,
}: Props) => {
  return (
    <ControlledPhoneInput
      onIsoCodeChange={onIsoCodeChange}
      isSelectMenuDisabled={isSelectMenuDisabled}
      onBlur={onBlur}
      onPhoneValidationStatusChange={(isValid) => onPhoneValidationStatusChange?.(isValid)}
      name={OnboardingFormFields.PHONE_NUMBER}
      id={OnboardingFormFields.PHONE_NUMBER}
      title={t('pages.phone.phoneFieldTitle')}
      disabled={disabled}
      tabindex={tabIndex}
      initialIsoCode={initialIsoCode}
      filteredCountries={filteredCountries}
      data-testid={OnboardingFormFields.PHONE_NUMBER}
    />
  );
};
